import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import subtraction from "assets/icons/Subtraction.png";
import ContactPersonIcon from "assets/icons/ContactPersonIcon";
import TextField from "common/TextField";
import "react-phone-input-2/lib/style.css";
import { useTranslation } from "react-i18next";
const Step2 = ({
  formik,
  handleBack,
  handleNext,
  handleError,
  handleCompletion,
}) => {
  const { t } = useTranslation();
  const STEP_ID = 2;

  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    userFirstName,
    userLastName,
    userEmail,
    cotactPersonIsEA,
  } = formik.values;
  const [disabled, setDisabled] = useState(() =>
    firstName.length > 0 &&
    lastName.length > 0 &&
    email.length > 0 &&
    phoneNumber.length > 7 &&
    !formik.errors.email &&
    userFirstName.length > 0 &&
    userLastName.length > 0 &&
    userEmail.length > 0 &&
    !formik.errors.userEmail
      ? false
      : true
  );

  useEffect(() => {
    setDisabled(
      firstName.length > 0 &&
        lastName.length > 0 &&
        email.length > 0 &&
        phoneNumber.length > 6 &&
        !formik.errors.email &&
        userFirstName.length > 0 &&
        userLastName.length > 0 &&
        userEmail.length > 0 &&
        !formik.errors.userEmail
        ? false
        : true
    );
  }, [
    firstName,
    lastName,
    email,
    phoneNumber,
    formik.errors.email,
    userFirstName,
    userLastName,
    userEmail,
    formik.errors.userEmail,
  ]);

  useEffect(() => {
    if (!disabled) {
      handleError(STEP_ID, false);
      handleCompletion(STEP_ID, true);
    } else if (disabled) {
      handleError(STEP_ID, true);
      handleCompletion(STEP_ID, false);
    }
  }, [disabled]);
  const handleCotactPersonIsEA = () => {
    formik.setFieldValue("userFirstName", firstName);
    formik.setFieldValue("userLastName", lastName);
    formik.setFieldValue("userEmail", email);
  };
  useEffect(() => {
    cotactPersonIsEA && handleCotactPersonIsEA();
  }, [cotactPersonIsEA]);
  const handleFirstNameChange = (e) => {
    if (cotactPersonIsEA) {
      formik.setFieldValue("firstName", e.target.value);
      formik.setFieldValue("userFirstName", e.target.value);
    } else {
      formik.handleChange(e);
    }
  };
  const handleLastNameChange = (e) => {
    if (cotactPersonIsEA) {
      formik.setFieldValue("lastName", e.target.value);
      formik.setFieldValue("userLastName", e.target.value);
    } else {
      formik.handleChange(e);
    }
  };
  const handleEmailChange = (e) => {
    if (cotactPersonIsEA) {
      formik.setFieldValue("email", e.target.value);
      formik.setFieldValue("userEmail", e.target.value);
    } else {
      formik.handleChange(e);
    }
  };

  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <h6 className="d-flex align-items-center">
        <ContactPersonIcon />
        <span className="mx-2">{t("contact-person")}</span>
      </h6>
      <p className="mt-2">{t("contact-person-description")}</p>
      <div className="inputField mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("first-name")}
          name="firstName"
          onChange={handleFirstNameChange}
          value={formik?.values?.firstName}
          error={
            formik.errors.firstName && formik.touched.firstName
              ? formik.errors.firstName
              : ""
          }
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("last-name")}
          name="lastName"
          onChange={handleLastNameChange}
          value={formik?.values?.lastName}
          error={formik.touched.lastName && formik.errors.lastName}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("email-address")}
          name="email"
          onChange={handleEmailChange}
          value={formik?.values?.email}
          error={formik.touched.email && formik.errors.email}
        />
      </div>
      <div className="inputField  mt-2">
        <PhoneInput
          country={"de"}
          value={phoneNumber}
          onChange={(phone) => {
            formik.setFieldValue("phoneNumber", phone);
          }}
          placeholder={t("phone-no")}
          containerClass="phoneNumberContainer"
          inputClass="phoneNumberInput"
        />
      </div>

      <h6 className="mt-4 d-flex align-items-center">
        <img src={subtraction} />
        <span className="mx-2">{t("eg-admin-users")}</span>
      </h6>
      <p className="mt-2">{t("eg-admin-users-description")}</p>
      <div className="inputField mt-2">
        {/* {firstName.length > 0 &&
          lastName.length > 0 &&
          email.length > 0 &&
          !formik.errors.email && ( */}
        <div className="d-flex justify-content-between align-items-center px-2 mb-2">
          <p className="m-0">{t("if-contact-person-is-branch-admin")}</p>
          <input
            type="checkbox"
            name="cotactPersonIsEA"
            onChange={formik?.handleChange}
            checked={cotactPersonIsEA}
          />
        </div>
      </div>
      <div className="inputField mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("first-name")}
          name="userFirstName"
          onChange={handleFirstNameChange}
          value={formik?.values?.userFirstName}
          error={
            (formik.touched.userFirstName && formik.errors.userFirstName) || ""
          }
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="text"
          className="form-control"
          placeholder={t("last-name")}
          name="userLastName"
          onChange={handleLastNameChange}
          value={formik?.values?.userLastName}
          error={formik.errors.userLastName || ""}
        />
      </div>
      <div className="inputField  mt-2">
        <TextField
          type="email"
          className="form-control"
          placeholder="E.g. johndoe@branch.com"
          name="userEmail"
          onChange={handleEmailChange}
          value={formik?.values?.userEmail}
          error={(formik.touched.userEmail && formik.errors.userEmail) || ""}
        />
      </div>

      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            marginRight: "15px",
            backgroundColor: "gray",
          }}
          onClick={handleBack}
        >
          {t("back")}
        </button>
        <button
          className="parentbtn"
          onClick={handleNext}
          style={{
            padding: "10px 35px",
            ...(disabled && { filter: "  opacity(30%)" }),
          }}
          disabled={disabled}
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
};

export default Step2;
